module.exports = __webpack_public_path__ + "static/media/ic_refresh.234d1157.svg";